import PropTypes from 'prop-types';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Divider } from '@mui/material';
import { numberToWords } from './utils';
import ThermalContentHeader from './ThermalContentHeader';

export default function BulkCancelInvoiceThermalContent({ formData }) {
    const {customerInfo, invoiceData} = formData;
    if (!invoiceData) {
        return null;
    }
    const { totalAmount, items } = invoiceData;
    const totalInWords = `Rs. ${numberToWords(Math.round(totalAmount))} Only`;

    return (
        <Box
            sx={{
                maxWidth: "72mm",
                width: "72mm",
                fontSize: "9px",
                "& .MuiTableCell-root": { p: "2px", fontSize: "13px" }, // Table cells padding
                "@media print": { fontSize: "13px" },
            }}
        >
            <ThermalContentHeader invoiceData={invoiceData} customerInfo={customerInfo} />

            {/* Table of Tests */}
            <TableContainer>
                <Table size="small">
                    <TableHead style={{ borderTopColor: 'black', borderBottomColor: 'black' }}>
                        <TableRow>
                            <TableCell style={{ fontSize: "10px", paddingLeft: '0' }}>#</TableCell>
                            <TableCell style={{ fontSize: "10px" }}>Description</TableCell>
                            <TableCell style={{ fontSize: "10px" }} align="center">Qty</TableCell>
                            <TableCell style={{ fontSize: "10px" }} align="right">Amount</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* Active Items */}
                        {items.map((item, i) => (
                            <TableRow key={i}>
                                <TableCell style={{ fontSize: "10px", paddingLeft: '0' }}>{i + 1}</TableCell>
                                <TableCell style={{
                                    fontSize: "10px",
                                    overflowWrap: 'break-word',
                                    wordBreak: 'break-word',
                                    whiteSpace: 'normal',
                                    maxWidth: '25ch'
                                }}>{item.name}</TableCell>
                                <TableCell align="center" style={{ fontSize: "10px" }}>
                                    {item.quantity || 1}
                                </TableCell>
                                <TableCell align="right" style={{ fontSize: "10px" }}>
                                    ₹{(item.amount || 0).toFixed(2)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Divider sx={{ my: 0.5, borderColor: 'black' }} />

            {/* Billing Summary */}
            <Box sx={{ textAlign: 'right', fontSize: '11px' }}>

                <Divider sx={{ my: 0.3, borderStyle: 'dashed' }} />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>Cancelled Value: (Grand Total)</Typography>
                    <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>₹{totalAmount.toFixed(2)}</Typography>
                </Box>
            </Box>

            <Typography sx={{ textAlign: "center", fontSize: "13px", fontStyle: 'italic' }}>
                {totalInWords}
            </Typography>

            <Divider sx={{ my: 0.5, borderColor: 'black' }} />

            {/* Footer */}
            <Typography sx={{ mt: 1, fontWeight: 'bold', textAlign: "center", fontSize: "13px" }}>
                नर सेवा नारायण सेवा
            </Typography>
        </Box>
    );
}

BulkCancelInvoiceThermalContent.propTypes = {
    customerInfo: PropTypes.object.isRequired,
    invoiceData: PropTypes.object.isRequired
};
